import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type OnboardingArea = 'dashboard' | 'settings'

export type OnboardingState = {
  isActive: boolean
  currentStep: number

  // ✅ separate completions
  completed: Record<OnboardingArea, boolean>

  // optional: can be used to “force” settings after dashboard
  shouldStartSettingsAfterDashboard: boolean

  startWizard: () => void
  stopWizard: () => void
  completeWizard: (area: OnboardingArea) => void
  setStep: (step: number) => void
  resetWizard: (area?: OnboardingArea) => void
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    set => ({
      isActive: false,
      currentStep: 0,

      completed: {
        dashboard: false,
        settings: false,
      },

      shouldStartSettingsAfterDashboard: false,

      startWizard: () => set({ isActive: true }),

      stopWizard: () => set({ isActive: false }),

      // ✅ mark only that area completed
      completeWizard: area =>
        set(state => ({
          isActive: false,
          completed: { ...state.completed, [area]: true },
          currentStep: 0,
          shouldStartSettingsAfterDashboard: area === 'dashboard' ? true : false,
        })),

      setStep: step => set({ currentStep: step }),

      // ✅ reset either one or all
      resetWizard: (area?: OnboardingArea) =>
        set(state => {
          if (!area) {
            return {
              isActive: false,
              currentStep: 0,
              completed: { dashboard: false, settings: false },
              shouldStartSettingsAfterDashboard: false,
            }
          }
          return {
            isActive: false,
            currentStep: 0,
            completed: { ...state.completed, [area]: false },
            shouldStartSettingsAfterDashboard: false,
          }
        }),
    }),
    {
      name: 'onboarding-store',
      partialize: state => ({
        completed: state.completed,
        shouldStartSettingsAfterDashboard: state.shouldStartSettingsAfterDashboard,
      }),
    }
  )
)
